import axios from "axios/index";
import Config from '../config';
import {notification} from "../helpers";


export function post(data){


    return (dispatch)=>{

        dispatch({
            type: 'CARS_CREATE_INPROGRESS',
            payload: data
        });
        return axios.post(Config.api.getDomain() + 'admin/createWheel', data, Config.api.getConfig())
            .then(response => {

                notification('Skapa lyckat!');

                dispatch({
                    type: 'CARS_CREATE_SUCCESS',
                    payload: response
                });
            })
            .catch(error => {

                if (typeof(error.response)!=="undefined" && typeof(error.response.data)!=="undefined"){

                    let errorCodes = error.response.data;
                    if (typeof(errorCodes)!=="undefined" && typeof(errorCodes.message)!=="undefined"){
                        notification('Skapa misslyckades! '+errorCodes.message);
                    } else {
                        notification('Skapa misslyckades!');
                    }

                } else {
                    notification('Skapa misslyckades!');
                }

                dispatch({
                    type: 'CARS_CREATE_FAILURE',
                    payload: error
                });
            })
    }
}


export function put(data){
    if (Number.isInteger(parseInt(data.id, 10))) {
        return (dispatch) => {
            dispatch({
                type: 'CARS_UPDATE_INPROGRESS',
                payload: data
            });
            return axios.post(Config.api.getDomain() + 'admin/updateWheel', data, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {key:"SearchTable"}
                });
                dispatch({
                    type: 'CARS_UPDATE_SUCCESS',
                    payload: response
                });
                notification("Uppdatering lyckades!");
                return Promise.resolve(true);
            }).catch(error => {

                dispatch({
                    type: 'CARS_UPDATE_FAILURE',
                    payload: error
                });
                let errorCodes = error.response.data;
                if (typeof(errorCodes)!=="undefined" && typeof(errorCodes.message)!=="undefined"){
                    notification('Uppdateringen misslyckades! '+errorCodes.message);
                } else {
                    notification('Uppdateringen misslyckades! ');
                }
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'CARS_UPDATE_FAILURE',
                payload: {"message": "No car id"}
            });
        };
    }
}


// WEBPACK FOOTER //
// ./src/actions/cars.js